module.exports = __webpack_public_path__ + "img/7.07297b6d.jpeg";